import { useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { PageHeading } from '@/components/subscription/page-heading'
import { Button } from '@/components/subscription/button'
import { TextLink } from '@/components/subscription/text-link'
import { formatTime } from '@/lib/shipment'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { Account } from '@/api-client/Account'
import { styles } from './styles.css'

export const loader = async () => {
  return await fetchSubscriptions()
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions()
}

export const SubscriptionMypageDelete: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData<typeof loader>()
  const [errorMessage, setErrorMessage] = useState('')

  const navigate = useNavigate()
  const subscription = subscriptions[0]
  const [checked, setChecked] = useState(false)

  const handleClickCancel: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try {
      await createClient(Account).deleteAccount()
      navigate('/subscription', { state: { message: 'アカウントを削除しました。FLOWERをご利用いただきありがとうございました。' } })
    } catch (error) {
      setErrorMessage(error.response.data.error.message_displayable)
    }
  }

  return (
    <Flex direction="column" align="center" gap="40px">
      <Flex direction="column" align="center" gap="32px" width="100%">
        <PageHeading>アカウントの削除</PageHeading>
        {subscription && (
          <p className={styles.warn}>
            {formatTime(1000 * subscription.attributes.skip_deadline)}までのお手続きで、
            <br />
            次回発送分から定期便を停止できます
          </p>
        )}
      </Flex>
      <Flex direction="column" align="start" gap="8px" width="100%">
        <h3 className={styles.heading}>必ずお読みください</h3>
        <ul className={styles.list}>
          {subscription && <li>上記の期限を過ぎてしまった場合は、次回のお届けをキャンセルできません。</li>}
          <li>注文履歴や個人情報など、すべての情報が削除されます。</li>
          <li>一度アカウントを削除すると、今後同じユーザー情報でログインできなくなります。</li>
          {subscription && (
            <li>
              アカウントは削除せず、定期便のみ停止したい場合は<Link to="/subscription/mypage/cancel">こちら</Link>からお手続きいただけます。
            </li>
          )}
        </ul>
      </Flex>
      <label className={styles.checkbox}>
        <Flex direction="row" align="center" gap="4px">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>注意事項を確認しました</span>
        </Flex>
      </label>
      <Flex direction="column" align="center" gap="32px" width="100%">
        <Flex direction="column" align="center" gap="16px" width="100%">
          {!!errorMessage && <p>{errorMessage}</p>}
          <Button as="button" size="m" tone="danger" fluid disabled={!checked} onClick={handleClickCancel}>
            FLOWERのアカウントを削除
          </Button>
        </Flex>
        <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
      </Flex>
    </Flex>
  )
}
